module.exports = __webpack_public_path__ + "images/emoji/santa.85f6912c34118734c2b2.png";